import request from '@/utils/request'

let UserApi = {

    /*用户登录*/
    login(data) {
        return request._post('/shop/passport/login', data);
    },
    /*退出登录*/
    loginOut(data) {
        return request._post('/shop/passport/logout', data);
    },
    /*添加用户*/
    adduser(data) {
        return request._post('/shop/user.user/add', data);
    },
    /*批量修改会员等级*/
    BatchChangegrade(data) {
      return request._post('/shop/user.user/BatchChangegrade', data);
    },
    /*批量禁用会员*/
    UserForbidden(data) {
      return request._post('/shop/user.user/UserForbidden', data);
    },
    /*批量解封会员*/
    batchRelieve(data) {
      return request._post('/shop/user.user/UserRelieve', data);
    },

    /*修改用户*/
    edituser(data) {
        return request._post('/shop/user.user/edit', data);
    },

    /*修改用户*/
    editAdd(data) {
        return request._post('/shop/user.user/editAdd', data);
    },

    /*充值*/
    userRecharge(data) {
        return request._post('/shop/user.user/recharge', data);
    },
    /*删除用户*/
    deleteuser(data) {
        return request._post('/shop/user.user/delete', data);
    },

    /*用户列表*/
    userlist(data) {
        return request._post('/shop/user.user/index', data);
    },
    /*等级列表*/
    graelist(data) {
        return request._post('/shop/user.grade/index', data);
    },
    /*等级列表*/
    gradeOrderList(data) {
        return request._post('/shop/user.grade/order', data);
    },
    /*添加等级*/
    addgrade(data) {
        return request._post('/shop/user.grade/add', data);
    },
    /*修改等级*/
    editGrade(data) {
        return request._post('/shop/user.grade/edit', data);
    },
    /*删除等级*/
    deletegrade(data) {
        return request._post('/shop/user.grade/delete', data);
    },
    /*用户余额*/
    BalanceLog(data) {
        return request._post('/shop/user.Balance/log', data);
    },
    /*充值记录*/
    RechargeOrder(data) {
        return request._post('/shop/user.Recharge/order', data);
    },
    /*修改密码*/
    EditPass(data) {
        return request._post('/shop/passport/editPass', data);
    },

    /* 新增   */

    /* 省列表 */
    provinceList(data) {
        return request._get('/shop/user.UserRegion/provinceList', data);
    },
    /* 市列表 */
    city_list(data) {
        return request._get('/shop/user.UserRegion/cityList', data);
    },
    /* 区域列表 */
    region_list(data) {
        return request._get('/shop/user.UserRegion/regionList', data);
    },
    /*  客户地区详细信息 */
    getCustomerData(data) {
        return request._post('/shop/user.UserRegion/getCustomerData', data);
    },
    /* 会员设置 */
    settingDetail(data) {
        return request._get('/shop/user.Setting/index', data);
    },
    editSetting(data) {
        return request._post('/shop/user.Setting/index', data);
    },
    /*用户关系*/
    relation(data) {
        return request._post('/shop/user.user/relation', data);
    },
    /*佣金记录*/
    AgentLog(data) {
        return request._post('/shop/user.agent_log/index', data);
    },
    /*会员等级变更记录*/
    gradeLog(data) {
        return request._post('/shop/user.grade/log', data);
    },
    /*查看用户结构列表*/
    userStructure(data) {
      return request._post('/shop/user.user/userStructureList', data);
    },
    /*根据用户id 获取下级信息,主要是给前端查看用户结构用*/
    getChildren(data) {
      return request._post('/shop/user.user/getChildren', data);
    },
    /*根据用户id 获取下级信息,主要是给前端查看用户结构用*/
    getSuperior(data) {
      return request._post('/shop/user.user/getSuperior', data);
    },


    /*会员升级规则列表*/
    graelist_up(data) {
        return request._post('/shop/user.upgrade/index', data);
    },
    // /*会员升级规则列表*/
    // gradeOrderList(data) {
    //     return request._post('/shop/user.grade/order', data);
    // },
    /*添加会员升级规则*/
    addgrade_up(data) {
        return request._post('/shop/user.upgrade/add', data);
    },
    /*修改会员升级规则*/
    editGrade_up(data) {
        return request._post('/shop/user.upgrade/edit', data);
    },
    /*删除会员升级规则*/
    deletegrade_up(data) {
        return request._post('/shop/user.upgrade/delete', data);
    },
    /*获取等级*/
    getGrade_up(data) {
        return request._post('/shop/user.upgrade/getGrade_up', data);
    },
    /*导入旧用户*/
    importOldUsers(data) {
        return request._post('/shop/user.user/importOldUsers', data);
    },

}

export default UserApi;



// WEBPACK FOOTER //
// ./src/api/user.js